var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossPlatformIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.772461,
    width: 40,
    height: 39.9698,
    rx: 10,
    fill: "#FDAD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9897 20.2177C24.7957 20.2177 26.2597 18.7547 26.2597 16.9501C26.2597 15.1455 24.7957 13.6826 22.9897 13.6826C21.1838 13.6826 19.7197 15.1455 19.7197 16.9501C19.7197 18.7547 21.1838 20.2177 22.9897 20.2177Z",
    stroke: "#FDAD00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6204 28.4116C28.8187 28.4135 29.0145 28.3662 29.1902 28.274C29.3658 28.1818 29.5158 28.0475 29.6268 27.8832C29.7378 27.7188 29.8062 27.5296 29.826 27.3323C29.8459 27.135 29.8164 26.9359 29.7403 26.7528C29.2024 25.4017 28.271 24.2429 27.0667 23.4266C25.8624 22.6102 24.4406 22.1738 22.9854 22.1738C21.5301 22.1738 20.1083 22.6102 18.904 23.4266C17.6997 24.2429 16.7683 25.4017 16.2303 26.7528C16.1607 26.9358 16.1366 27.1329 16.1601 27.3272C16.1835 27.5216 16.2538 27.7073 16.365 27.8685C16.4761 28.0297 16.6248 28.1615 16.7982 28.2526C16.9715 28.3437 17.1645 28.3914 17.3604 28.3916L28.6204 28.4116Z",
    stroke: "#FDAD00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 20.2475C16.1765 20.2475 17.2599 19.1648 17.2599 17.8293C17.2599 16.4938 16.1765 15.4111 14.8399 15.4111C13.5034 15.4111 12.4199 16.4938 12.4199 17.8293C12.4199 19.1648 13.5034 20.2475 14.8399 20.2475Z",
    stroke: "#FDAD00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8399 23.5054C18.22 22.8235 17.4344 22.3129 16.5592 22.023C15.6841 21.7331 14.7489 21.6737 13.844 21.8505C12.9391 22.0274 12.0952 22.4344 11.3938 23.0324C10.6924 23.6304 10.1572 24.399 9.83995 25.2641C9.80764 25.3812 9.8028 25.5041 9.8258 25.6233C9.8488 25.7426 9.89902 25.8549 9.97256 25.9516C10.0461 26.0483 10.141 26.1267 10.2498 26.1808C10.3586 26.2348 10.4784 26.2631 10.5999 26.2633H16.4999C17.0356 25.1621 17.8404 24.2136 18.8399 23.5054V23.5054Z",
    stroke: "#FDAD00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPlatformIcon);
export default __webpack_public_path__ + "static/media/crossPlatformIcon.7fd8b11b9b6b27cb21c0557a4627379e.svg";
export { ForwardRef as ReactComponent };